module.exports = __webpack_public_path__ + "img/8.cc14854a.jpg";